import React, { useEffect } from 'react';
import { ShortMsgCheckIcon } from '../../images/svgIcons';
import { AutoCloseModalStyles } from './styles';

const AutoCloseModal = ({
  visible = false,
  onClose = () => {},
  closeTimeoutSec = 5,
  text = '',
  children,
}) => {
  useEffect(() => {
    if (!visible) return;

    const timer = setTimeout(() => {
      onClose();
    }, closeTimeoutSec * 1000);

    return () => clearTimeout(timer);
  }, [visible]);

  return (
    <>
      <AutoCloseModalStyles visible={visible} closable={false} closeTimeoutSec={closeTimeoutSec} onCancel={onClose} maskClosable={true}>
        <div className="time-progress-bar"></div>
        {children ? (
          children
        ) : (
          <div className="success">
            <div className="check-icon">
              <ShortMsgCheckIcon size="80px" colors={['#32cd32', '#addfad', '#32cd32']} />
            </div>
            <h4>{text}</h4>
          </div>
        )}
      </AutoCloseModalStyles>
    </>
  );
};

export default AutoCloseModal;
